import {ActionType} from "typesafe-actions";
import * as actions from "./actions";
import {select} from "redux-saga/effects";
import {IApplicationState} from "../index";
import {addCoins} from "./actions";
import {addScore} from "./actions";
import {Random} from "../../shared/utils/random";
import {addLives} from "./actions";
import {addBonus} from "./actions";

export interface IPlayerState extends Partial<IPlayer> {
    readonly lives: number;
    readonly coins: number;
    readonly score: number;
    readonly levelsCompleted: number;
    readonly bonuses: Record<number, number>;
    readonly lastLiveIncrementTimestamp: number;
    readonly settings: IPlayerSettings;
}

export type PlayerActions = ActionType<typeof actions>;

//------------------------

export interface IPlayer {
    readonly id: string;
    readonly name: string;
    readonly picture: string;
    readonly signature: string;
}

export interface IPlayerSettings {
    readonly music: boolean;
    readonly sounds: boolean;
    readonly shortcutCreated: boolean;
}

export enum BonusType {
    None = 0,
    Coins = 10,
    FiftyFifty = 20,
    DoubleChance = 30,
    SkipQuestion = 40,
    MajorityVote = 50,
    RevealMap = 60,
    RevealTile = 70,
    ShowExit = 80,
    Lives = 90,
    Score = 100
}

export function getBonusGroup(bonus: BonusType) {
    switch (bonus) {
        case BonusType.Coins:
        case BonusType.Score:
        case BonusType.Lives:
            return 'misc';

        case BonusType.RevealMap:
        case BonusType.RevealTile:
        case BonusType.ShowExit:
            return 'level';

        case BonusType.FiftyFifty:
        case BonusType.DoubleChance:
        case BonusType.SkipQuestion:
        case BonusType.MajorityVote:
            return 'question';
    }
}

export function isBonusAction(action: ActionType<typeof addBonus> | ActionType<typeof addCoins> | ActionType<typeof addScore> | ActionType<typeof addLives>): action is ActionType<typeof addBonus> {
    return (action as ActionType<typeof addBonus>).payload.bonus !== undefined;
}

export function* getTileBonusAction(bonus: BonusType, seed: number, source?: string) {
    const {bonusCoins, bonusScore, randomSeed} = yield select(({ settings }: IApplicationState) => ({
        bonusCoins: settings.miniGames.bonusCoins,
        bonusScore: settings.miniGames.bonusScore,
        randomSeed: settings.randomSeed
    }));

    const random = new Random(randomSeed ^ seed);

    switch (bonus) {
        case BonusType.None:
            return undefined;

        case BonusType.Coins:
            return addCoins(Math.floor(random.spread(bonusCoins, 0.5)), source);

        case BonusType.Score:
            return addScore(Math.floor(random.spread(bonusScore, 0.5)), source);

        case BonusType.Lives:
            return addLives(1, source);

        default:
            return addBonus({ bonus: bonus!, count: 1 }, source);
    }
}

export function getAddBonusAction(bonus: BonusType, count: number, source?: string) {
    switch (bonus) {
        case BonusType.None:
            return undefined;

        case BonusType.Coins:
            return addCoins(count, source);

        case BonusType.Score:
            return addScore(count, source);

        case BonusType.Lives:
            return addLives(count, source);

        default:
            return addBonus({ bonus: bonus, count: count }, source);
    }
}